// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"eb4ff720","590":"978381ca","655":"1dbf9f2b","793":"688afdfb"}[chunkId] + ".chunk.js";
};